// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__xQr4X","title":"AfterFrontImage_title__1WUXF"};